var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoublebed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 24,
    viewBox: "0 0 29 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe 442",
    clipPath: "url(#clip0_314_433)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe 442_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g4234"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4236",
    d: "M25.2435 11.0729H3.75713C2.87281 11.0639 2.02115 11.4061 1.38931 12.0244C0.757459 12.6427 0.39715 13.4864 0.387695 14.37V23.041C0.389985 23.1935 0.452224 23.3389 0.560955 23.446C0.669686 23.553 0.816215 23.6129 0.968835 23.6129H1.93734C2.08996 23.6129 2.23643 23.553 2.34516 23.446C2.45389 23.3389 2.51613 23.1935 2.51842 23.041V22.2387C2.52007 22.079 2.55319 21.9211 2.6159 21.7742C2.6786 21.6272 2.7697 21.494 2.88392 21.3822C2.99814 21.2704 3.13323 21.1822 3.28157 21.1226C3.42991 21.063 3.58857 21.0332 3.74844 21.0349H25.2348C25.3946 21.0332 25.5533 21.063 25.7016 21.1226C25.85 21.1822 25.9851 21.2704 26.0993 21.3822C26.2135 21.494 26.3046 21.6272 26.3673 21.7742C26.43 21.9211 26.4631 22.079 26.4648 22.2387V23.041C26.4671 23.1935 26.5293 23.3389 26.638 23.446C26.7468 23.553 26.8932 23.6129 27.0459 23.6129H28.0144C28.167 23.6129 28.3135 23.553 28.4223 23.446C28.531 23.3389 28.5932 23.1935 28.5955 23.041V14.37C28.5863 13.4894 28.2285 12.6482 27.6004 12.0303C26.9723 11.4125 26.1248 11.0683 25.2435 11.0729Z",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4238"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4240",
    d: "M2.07968 17.3293H0.387695",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4242"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4244",
    d: "M28.613 17.3293H4.04004",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4246"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4248",
    d: "M5.67383 10.7826V7.15164C5.67383 6.96069 5.74975 6.77756 5.88488 6.64253C6.02001 6.5075 6.20329 6.43164 6.3944 6.43164H11.4374C11.532 6.43164 11.6257 6.45027 11.7132 6.48645C11.8006 6.52264 11.88 6.57567 11.9469 6.64253C12.0138 6.70939 12.0669 6.78876 12.1031 6.87611C12.1393 6.96347 12.158 7.05709 12.158 7.15164V10.7826",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4250"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4252",
    d: "M16.8438 7.6277V7.14383C16.8438 6.95287 16.9197 6.76974 17.0548 6.63471C17.1899 6.49968 17.3732 6.42383 17.5643 6.42383H22.6073C22.702 6.42383 22.7957 6.44245 22.8831 6.47863C22.9705 6.51482 23.0499 6.56785 23.1169 6.63471C23.1838 6.70157 23.2368 6.78094 23.2731 6.86829C23.3093 6.95565 23.3279 7.04928 23.3279 7.14383V10.7748",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4254"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4256",
    d: "M16.7393 10.8204V9.61945",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g4258"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path4260",
    d: "M27.0798 11.1514V4.65588C27.0781 4.49885 27.0453 4.34369 26.9835 4.1993C26.9217 4.05491 26.832 3.9241 26.7196 3.81436C26.6072 3.70463 26.4742 3.61812 26.3283 3.55976C26.1823 3.5014 26.0263 3.47234 25.8692 3.47426H23.1158C21.8809 3.47628 20.684 3.0474 19.7318 2.26167C18.2613 1.04524 16.4108 0.382012 14.5018 0.387176C12.5928 0.382012 10.7424 1.04524 9.27192 2.26167C8.31974 3.0474 7.12285 3.47628 5.88794 3.47426H3.13446C2.9773 3.47234 2.82131 3.5014 2.67539 3.55976C2.52947 3.61812 2.3965 3.70463 2.28406 3.81436C2.17163 3.9241 2.08194 4.05491 2.02012 4.1993C1.95831 4.34369 1.9256 4.49885 1.92383 4.65588V11.1514",
    stroke: "black",
    strokeWidth: 0.8,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_314_433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 29,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoublebed);
export default __webpack_public_path__ + "static/media/doublebed.41e70ca6860a724b9e8d80d0d68181f9.svg";
export { ForwardRef as ReactComponent };